module.exports = __webpack_public_path__ + "d2b132aa928480064fec9bcbd1970f98.svg";